/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Recording_TitleInputs */



/**
* | output |
* | --- |
* | "Wundo is recording" |
*
* @param {Meeting_Offline_Recording_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_recording_title = /** @type {((inputs?: Meeting_Offline_Recording_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Recording_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo neemt op")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo enregistre")
	return /** @type {LocalizedString} */ ("Wundo is recording")
});